var w = /* @__PURE__ */ new WeakMap();
var weakKey = function weakKey2(item) {
  var _w_get;
  return (_w_get = w.get(item)) !== null && _w_get !== void 0 ? _w_get : (function() {
    var k = `${Math.random()}`;
    w.set(item, k);
    return k;
  })();
};
export {
  weakKey
};
//# sourceMappingURL=weakKey.js.map
